import { useForm } from "react-hook-form";
import FormControlLabel from "../mui/FormControlLabel";
import Typography from "../mui/Typography";
import Stack from "../mui/Stack";
import Checkbox from "../../components/mui/Checkbox";
import styled from "@emotion/styled";
import FormControl from "../mui/FormControl";
import FormHelperText from "../mui/FormHelperText";
import AutoComplete from "../mui/AutoComplete";
import Box from "../mui/Box";

interface RatioButton {
  label: string;
  value: string;
}

interface QcFilterFormProps {
  ratiobtn: RatioButton[];
  centerList: any;
  filter: any;
  handleFilterFormChange: (field: string, value: any) => void;
}

const StyledLabel = styled(Box)(({ theme }) => ({
  fontSize: "14px !important",
  marginBottom: "3px !important",
  fontWeight: "500 !important",
  color: "#191919 !important",
}));

const TargetAchivmentfilterForm: React.FC<QcFilterFormProps> = ({
  ratiobtn,
  centerList,
  filter,
  handleFilterFormChange,
}) => {
  return (
    <Stack sx={{ gap: "10px" }}>
      <Stack>
        <Typography>Region</Typography>
        <StyledCheckboxGroup>
          {ratiobtn.map((btn) => (
            <FormControlLabel
              key={btn.value}
              control={
                <Checkbox
                  // {...register("filter.region")}
                  checked={filter.region.includes(btn.value)}
                  onChange={() => handleFilterFormChange("region", btn.value)}
                  sx={{
                    "&.Mui-checked": {
                      color: "#FFCA09",
                    },
                    marginRight: "-7px",
                  }}
                />
              }
              label={btn.label}
              value={btn.value}
            />
          ))}
        </StyledCheckboxGroup>
      </Stack>

      {[
        // { name: "medals", label: "Medals", options: centerList.medals },
        { name: "state", label: "State", options: centerList.stateOptions },
        { name: "city", label: "City", options: centerList.city },
        
        { name: "centers", label: "Centre", options: centerList.centerSelect },
        // {
        //   name: "regionalManager",
        //   label: "Regional director",
        //   options: centerList.regionalDirectorOptions,
        // },
        {
          name: "cityManager",
          label: "City Manager",
          options: centerList.cityManagerOptions,
        },
        // {
        //   name: "clusterManager",
        //   label: "Cluster manager",
        //   options: centerList.clusterManagerOptions,
        // },
        { name: "funder", label: "Funder", options: centerList.funderOptions },
      ].map(({ name, label, options }) => (
        <Stack key={name}>
          <Stack>
            <StyledLabel>
              {label}{" "}
              {label === "City" && (
                <span style={{ color: "#636363", fontSize: "12px" }}>
                  (Please first select a state)
                </span>
              )}
            </StyledLabel>{" "}
            <FormControl fullWidth>
              <AutoComplete
                id={`${name}-select`}
                options={options}
                placeholder={`Select ${label}`}
                value={filter[name] || []}
                onChange={(newValue: any) =>
                  handleFilterFormChange(`${name}`, newValue)
                }
                sx={{ backgroundColor: "#fff" }}
                disableClearable={false}
              />
              {/* <StyledFormHelperText>
                {error[`${name}`]?.message || " "}
              </StyledFormHelperText> */}
            </FormControl>
          </Stack>
        </Stack>
      ))}
    </Stack>
  );
};

const StyledCheckboxGroup = styled(Stack)({
  flexDirection: "row",
  marginRight: "8px",
});
const StyledStack = styled(Stack)(() => ({
  marginBottom: "15px",
}));
const StyledTypography = styled(Typography)(() => ({}));
const StyledFormHelperText = styled(FormHelperText)(() => ({
  marginLeft: "0px",
  color: "red",
}));

export default TargetAchivmentfilterForm;
